  if (!window.CourumCartQuickAddBound) {
    window.CourumCartQuickAddBound = true;
    document.addEventListener('change', function(event) {
      var color = event.target.closest('[data-courum-wallet-color]');
      if (!color) return;
      var recommendation = color.closest('.CourumCartRecommendations');
      var image = recommendation && recommendation.querySelector('[data-courum-wallet-image]');
      if (image && color.getAttribute('data-image')) image.src = color.getAttribute('data-image');
      var rawPrice = color.getAttribute('data-price');
      var cents = Number(rawPrice);
      if (!recommendation || rawPrice === null || !Number.isFinite(cents)) return;
      var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'BRL';

      var pixPrice = recommendation.querySelector('[data-courum-pix-price]');
      var pixAmount = pixPrice && pixPrice.querySelector('[data-courum-pix-amount]');

      if (pixPrice && pixAmount) {
        pixPrice.setAttribute('data-courum-pix-price', String(cents));
        pixAmount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
          style: 'currency', currency: currency || 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2
        }).format(Math.round(cents * 90 / 100) / 100);
      }
    });
    document.addEventListener('click', function(event) {
      var button = event.target.closest('[data-courum-quick-add]');
      if (!button || button.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      var recommendation = button.closest('.CourumCartRecommendations');
      var selectedColor = recommendation && recommendation.querySelector('[data-courum-wallet-color]:checked');
      if (!selectedColor) return;
      var originalLabel = button.textContent;
      var formData = new FormData();
      formData.append('id', selectedColor.value);
      formData.append('quantity', '1');
      button.disabled = true;
      button.textContent = 'ADICIONANDO...';
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      fetch('/cart/add.js', {
        credentials: 'same-origin',
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function(response) {
        if (!response.ok) throw new Error('Não foi possível adicionar esta carteira.');
        return response.json();
      }).then(function(variant) {
        if (recommendation) recommendation.remove();
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        document.dispatchEvent(new CustomEvent('product:added', { bubbles:true, detail:{ variant:variant, quantity:1 } }));
      }).catch(function(error) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        button.disabled = false;
        button.textContent = 'TENTAR NOVAMENTE';
        button.setAttribute('title', error.message);
        setTimeout(function() { button.textContent = originalLabel; }, 2400);
      });
    });
  }

